import ResendLastMessageLink from '../../messageExtensions/links/ResendLastMessageLink'
import InitChatLink from '../../messageExtensions/links/InitChatLink'
import AddFollowupLink from '../../messageExtensions/links/AddFollowupLink'
import EmailChatLogLink from '../../messageExtensions/links/EmailChatLogLink'
import MessageLink from '../../messageExtensions/links/MessageLink'
import ReloadPageLink from '../../messageExtensions/links/ReloadPageLink'
import SupportAgent from './SupportAgent'
import Attachments from '../../messageExtensions/blocks/Attachments'
import CommandButtons from '../../messageExtensions/blocks/CommandButtons'

import { ChatMessageExtensions } from '../../types'

const supportChatAssistantMessageExtensions: ChatMessageExtensions = {
  links: {
    '#init_chat': InitChatLink,
    '#new_chat': InitChatLink,
    '#add_followup': AddFollowupLink,
    '#email_chat_log': EmailChatLogLink,
    '#resend_last_message': ResendLastMessageLink,
    '#message:': MessageLink,
    '#reload_page': ReloadPageLink
  },
  blocks: {
    support_agent: SupportAgent,
    support_agent_assigned: SupportAgent,
    support_agent_reassigned: SupportAgent,
    support_agent_left: SupportAgent,
    attachments: Attachments,
    command_buttons: CommandButtons
  }
}

export default supportChatAssistantMessageExtensions
